export const breakpoints = {
  small: {
    value: 480,
  },
  medium: {
    value: 768,
  },
  large: {
    value: 1280,
  },
  xlarge: {
    value: 1440,
  },
};

export const deviceBreakpoints = {
  phone: 'small',
  tablet: 'medium',
  laptop: 'large',
  desktop: 'xlarge',
};
